/**
 * «رویدادهای دورریخته‌ی بیرون از پاکت» (WHOSUP-286) — منطقِ فیلتر و نمایش.
 *
 * داده از `admin_out_of_bag_events()` (مایگریشن 0157) می‌آید؛ این‌جا فقط
 * فیلتر روی پاکت/منبع و قالبِ تاریخ است، تا بی دیتابیس تست شود.
 */

export interface OutOfBagBag {
  bag: string;
  cities: string[];
  count: number;
  computed_at: string | null;
}

export interface OutOfBagEvent {
  bag: string;
  title: string | null;
  starts_at: string | null;
  event_city: string | null;
  /** منطقه‌ی زمانیِ شهرِ رویداد از `crawler.cities`؛ اگر شهر ناشناس است null. */
  event_tz: string | null;
  source_id: string | null;
  source_city: string | null;
  url: string | null;
  venue_address: string | null;
}

export interface OutOfBagReport {
  bags: OutOfBagBag[];
  events: OutOfBagEvent[];
  error?: string;
}

export function filterOutOfBag(
  events: OutOfBagEvent[], bag: string | null, source: string | null,
): OutOfBagEvent[] {
  return events.filter((e) => (!bag || e.bag === bag) && (!source || e.source_id === source));
}

/** منبع‌هایی که در فهرست هستند — برای منوی فیلتر، مرتب. */
export function outOfBagSources(events: OutOfBagEvent[], bag: string | null): string[] {
  const set = new Set<string>();
  for (const e of events) if (e.source_id && (!bag || e.bag === bag)) set.add(e.source_id);
  return [...set].sort();
}

/**
 * تاریخ به وقتِ شهرِ رویداد، نه مرورگر. اگر منطقه‌ی شهر معلوم نیست، همان
 * ساعتِ دیواریِ رشته‌ی منبع (که آفستِ خودش را دارد) با آفست نشان داده می‌شود
 * — حدسِ منطقه بدتر از نشان دادنِ خامِ آن است.
 */
export function formatOutOfBagStart(startsAt: string | null, tz: string | null): string {
  if (!startsAt) return '—';
  const d = new Date(startsAt);
  if (Number.isNaN(d.getTime())) return startsAt;
  if (!tz) return startsAt.replace('T', ' ');
  try {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(d);
    const p = (t: string) => parts.find((x) => x.type === t)?.value ?? '';
    return `${p('year')}-${p('month')}-${p('day')} ${p('hour')}:${p('minute')}`;
  } catch {
    return startsAt.replace('T', ' ');
  }
}
